module.exports = '<svg width="49" height="32" viewBox="0 0 49 32"><path d="M46.545 8.727h-2.909V2.909C43.636 1.3 42.336 0 40.727 0H2.909A2.908 2.908 0 0 0 0 2.909v26.182A2.908 2.908 0 0 0 2.909 32h37.818c1.609 0 2.909-1.3 2.909-2.909v-5.818h2.909c1.609 0 2.909-1.3 2.909-2.909v-8.727c0-1.609-1.3-2.909-2.909-2.909zm-11.636 5.818h-5.818v2.909h5.818v2.909h-5.818v2.909h-5.818c-1.609 0-2.909-1.455-2.909-2.257v-.652H8.728v-8.727h11.636c0-.803 1.3-2.909 2.909-2.909h5.818v2.909h5.818v2.909z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/battery-charging-1.js
// module id = 998
// module chunks = 14